import React from 'react';
import PropTypes from 'prop-types';
import Textarea from './Textarea';

const FormikTextarea = ({ field, form, ...props }) => <Textarea {...field} {...props} />;

FormikTextarea.propTypes = {
  field: PropTypes.shape({}).isRequired,
  form: PropTypes.shape({}).isRequired,
};

export default FormikTextarea;
